var map = {
	"./Logo-01.png": "fwX1",
	"./Logo-02-white.png": "aGBg",
	"./Logo-02.png": "NRIN",
	"./Logo-03.png": "fhOu",
	"./aboutpage-dot-ornament.png": "0L8M",
	"./gatsby-astronaut.png": "qRbu",
	"./gatsby-icon.png": "waaq",
	"./homepage-banner-bg.png": "8KLJ",
	"./homepage-dot-ornament.png": "Ck5e",
	"./logo-adhi-karya.png": "C48e",
	"./logo-alam-bali.png": "1aRq",
	"./logo-asdp.png": "A0hx",
	"./logo-bank-bni.png": "j/qd",
	"./logo-bank-bri.png": "wpRW",
	"./logo-bank-mandiri.png": "c2fV",
	"./logo-biofarma.png": "IdX+",
	"./logo-bpjs-tk.png": "0+43",
	"./logo-dapen-telkom.png": "ufYo",
	"./logo-gmf-aero-asia.png": "t/vb",
	"./logo-indah-kiat.png": "WhPd",
	"./logo-kimia-farma.png": "+Pyg",
	"./logo-kjpp.png": "KzyZ",
	"./logo-lippo-group.png": "zp4d",
	"./logo-mayapada-healthcare.png": "hSau",
	"./logo-perhutani.png": "tT/G",
	"./logo-perkebunan-nusantara.png": "5bA0",
	"./logo-pertamina.png": "Rngh",
	"./logo-pp-properti.png": "k7WQ",
	"./logo-ptpn-5.png": "dF+c",
	"./logo-ptpn-8.png": "KV7U",
	"./logo-taspen-properti.png": "Pp+1",
	"./logo-taspen.png": "787v",
	"./logo-wika-realty.png": "aeCG",
	"./ornamen-down-left.png": "2gfy",
	"./ornamen-down-right.png": "nMDr",
	"./ornamen-union.png": "dwj6",
	"./ornamen-up-right-blue.png": "xx9Y",
	"./ornamen-up-right-white.png": "Oozp",
	"./provalindo-chandra-rambey.png": "r7D8",
	"./provalindo-febriman-siregar.png": "zilR",
	"./provalindo-wiwit-nugroho.png": "wodN",
	"./tredo-logo.png": "JlvK"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1IgP";